import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/** Where a signed-in user belongs when they hit something they shouldn't. */
export const homeFor = (role?: string | null) =>
  role === 'client' ? '/portal/client'
  : role === 'employee' ? '/portal/employee'
  : '/dashboard';

// Admin-app guard: authentication AND staff role. Portal users (client/
// employee tokens) used to fall through here and RENDER admin pages — the
// client "Account" tab literally showed the company dashboard. They now
// bounce to their own portal home.
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
          <p className="text-sm text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role === 'client' || user?.role === 'employee') {
    return <Navigate to={homeFor(user.role)} replace />;
  }

  return <>{children}</>;
};

